import React from "react";
import style from './css/ContactUs.module.css'
import Footer from "./Footer";
import WhatsApp from "./WhatsApp";

function ContactUs() {
    return (
        <>
            <div className="container-fluid text-light py-4" style={{ background: '#2d2d2f' }}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <h2 className={`${style.heading} text-center text-warning py-3`}> Contact Us</h2>
                        <div className="col-lg-6">
                            <div className="d-flex align-items-center justify-content-center">
                                <h1 className='my-2 text-center'>
                                  SKY COMPUTER EDUCATION
                                </h1>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <h5 className={`${style.h5}my-4`}>
                                    Address: &nbsp; East of Naka No.- 5, Near Panchmukhi Hanuman Mandir,
                                    Mishratola, Darbhanga Bihar-846009
                                </h5>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <h5 className={`${style.h5} my-4`}>
                                    Mob: &nbsp; +919128414128, 7070985222
                                </h5>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3581.5738448861357!2d85.9005329!3d26.1454345!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39edb8462e7883d1%3A0x7c8b438a910ecf20!2sSKY%20Computer%20Education!5e0!3m2!1sen!2sin!4v1706086077050!5m2!1sen!2sin" width="100%" height="300" loading="lazy" allowFullScreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
            <WhatsApp/>
        </>
    );
}

export default ContactUs;
